/**
 * PAPPO — Staff service. Gestão de cargos da equipe (/api/staff).
 * Hierarquia gerente<master<dev; as travas de rank são aplicadas no backend.
 */
import { apiDelete, apiGet, apiPost } from './api';
import type { StaffRole } from '../types/user';

export interface StaffMember {
  id: number;
  username: string;
  display_name: string;
  email: string;
  staff_role: StaffRole;
  avatar_url: string | null;
}

/** Lista a equipe (todos os staff). Qualquer nível de staff pode ver. */
export async function listStaff() {
  return apiGet<{ members: StaffMember[] }>('/staff/members');
}

/** Nomeia um usuário (por email) para um cargo. Só master/dev. */
export async function promoteStaff(email: string, staff_role: StaffRole) {
  return apiPost('/staff/members', { email, staff_role });
}

/** Remove o cargo de staff de alguém. Só master/dev. */
export async function revokeStaff(id: number) {
  return apiDelete(`/staff/members/${id}`);
}
